/**
 * Centralized win detection and handling.
 *
 * Combines checkForWin() with the side effects that should fire once
 * when a win is detected: stop timer, record stats, save leaderboard
 * entry, play sound, and transition to the Completed state.
 *
 * Previously this block was duplicated 3x across canvasMouseMethods.ts
 * and autocompleteGame.ts.
 */

import { appState, checkForWin, setAppState, getUndoCount } from './state'
import { CurrentAppState } from '../Models/AppState'
import { UNDO_PENALTY_MS } from '../Models/GameRecord'
import { timerStop } from './timer'
import { recordGameWin, loadStatistics } from './statisticsManager'
import { saveRecord } from './recordsManager'
import { playSound } from './audioFunctions'
import { submitGameCenterScore, reportGameCenterAchievements } from './gameCenterManager'

/**
 * Check if the game is won, and if so, handle all win side effects.
 * @returns true if the game was won, false otherwise
 */
export function handleWinCheck(): boolean {
    if (!checkForWin()) return false

    const finalTime = timerStop()
    const undoCount = getUndoCount()
    recordGameWin(finalTime)
    saveRecord(finalTime, undoCount)
    playSound('win')

    // Game Center: submit score and report achievements (no-op if not on iOS / not authenticated)
    const computedTime = finalTime + undoCount * UNDO_PENALTY_MS
    submitGameCenterScore(computedTime)
    reportGameCenterAchievements(loadStatistics(), appState.settings.drawCount, undoCount, finalTime)

    const currentAppState = appState
    currentAppState.currentAppState = CurrentAppState.Completed
    currentAppState.showWinRecords = false
    setAppState(currentAppState)

    return true
}
